/* Dead Romance v2 — pure logic. Ports unchanged to assets/dr-v2-core.js.
   No DOM, no store data. Money is integer cents end to end. */
(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  else root.DRCore = api;
})(typeof self !== "undefined" ? self : this, function () {
  var MAP = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (m) { return MAP[m]; });
  }

  function money(cents, symbol) {
    var n = Math.round(Number(cents) || 0);
    return (symbol || "$") + (n / 100).toFixed(2);
  }

  /* Set width= on a CDN URL. Replaces an existing width in place, otherwise appends,
     so `v=` cache-busting survives and the URL never gains a second `?`. */
  function imgAt(url, width) {
    if (!url) return "";
    var parts = String(url).split("#")[0].split("?");
    var params = (parts[1] || "").split("&").filter(Boolean);
    var w = "width=" + width, replaced = false;
    params = params.map(function (p) {
      if (p.indexOf("width=") === 0) { replaced = true; return w; }
      return p;
    });
    if (!replaced) params.push(w);
    return parts[0] + "?" + params.join("&");
  }

  function mapCart(c) {
    var items = (c && c.items || []).map(function (l) {
      return {
        id: "cart-line-" + l.key,
        key: l.key,
        handle: l.handle,
        name: l.product_title,
        size: l.variant_title && l.variant_title !== "Default Title" ? l.variant_title : "",
        qty: l.quantity,
        linePrice: l.final_line_price,
        originalLinePrice: l.original_line_price,
        image: l.image || "",
        url: l.url || ("/products/" + l.handle),
        gift: !!(l.properties && l.properties._free_tee)
      };
    });
    return {
      items: items,
      count: (c && c.item_count) || 0,
      gross: (c && c.original_total_price) || 0,
      discount: (c && c.total_discount) || 0,
      total: (c && c.total_price) || 0
    };
  }

  function bogoState(state, eligibleHandles) {
    var ok = {};
    (eligibleHandles || []).forEach(function (h) { ok[h] = true; });
    var units = 0, off = 0, minUnit = Infinity;
    state.items.forEach(function (l) {
      if (!ok[l.handle] || !l.qty) return;
      units += l.qty;
      off += l.originalLinePrice - l.linePrice;
      minUnit = Math.min(minUnit, l.originalLinePrice / l.qty);
    });
    var mode = "none";
    if (units % 2 === 1) mode = "odd";
    /* "Free tee applied" only when the server's discount on eligible lines really
       covers one free unit per pair — any smaller discount (an older bundle rule, a
       stray code) must not be described as a free tee. */
    else if (units >= 2 && off >= (units / 2) * minUnit) mode = "even";
    return { units: units, mode: mode };
  }

  /* Spend-threshold free tee. "applied" only when the server has really made one eligible
     unit free; a tee picked in the cart (_free_tee) doesn't count toward the spend. */
  function giftState(state, eligibleHandles, threshold) {
    var ok = {};
    (eligibleHandles || []).forEach(function (h) { ok[h] = true; });
    if (!threshold || !state.items.length || !(eligibleHandles || []).length) return { mode: "none", remaining: 0, spend: 0 };
    var applied = false, picked = null;
    state.items.forEach(function (l) {
      if (!ok[l.handle] || !l.qty) return;
      if (l.originalLinePrice - l.linePrice >= l.originalLinePrice / l.qty) applied = true;
      if (l.gift) picked = l;
    });
    if (applied) return { mode: "applied", remaining: 0, spend: state.total };
    var spend = Math.max(0, state.total - (picked ? picked.originalLinePrice / picked.qty : 0));
    var remaining = Math.max(0, threshold - spend);
    if (picked) return remaining > 0 ? { mode: "keep", remaining: remaining, spend: spend } : { mode: "none", remaining: 0, spend: spend };
    if (remaining > 0) return { mode: "progress", remaining: remaining, spend: spend };
    return { mode: "pick", remaining: 0, spend: spend };
  }

  /* Tier bar: fill + which reward stops are reached. Every stop is reached once the tee is earned. */
  function tierState(g, threshold, stops) {
    var full = g.mode === "pick" || g.mode === "applied";
    return {
      fill: full ? 1 : Math.min(1, g.spend / threshold),
      reached: (stops || []).map(function (at) { return full || g.spend >= at; })
    };
  }

  return { esc: esc, money: money, imgAt: imgAt, mapCart: mapCart, bogoState: bogoState, giftState: giftState, tierState: tierState };
});
